/**
 * 収運・処分業者データ補完
 */
import * as httpConst from "@/constants/httpConst";
import Vue from "vue";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/transfers/trader_complements`

const getDefaultState = () => {
  return {}
}

const transferTraderComplement =  {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    /**
     * 収運・処分業者データ補完一覧
     * @param params {Object}
     * @param params.jwnet_manifest_ids {Array} JWNETマニフェストIDの配列
     */
    index ({ commit }, {params}) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    /**
     * 収運・処分業者データ補完 登録
     * @param commit
     * @param params
     * @returns {Promise<unknown>}
     */
    create({ commit }, { params }){
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  }
};

export default transferTraderComplement;
